import { jsx as _jsx } from "react/jsx-runtime";
import { BasicLayout } from './BasicLayout';
import { HeaderLayout } from './HeaderLayout';
import { SiderLayout } from './SiderLayout';
import { useLocation } from 'react-router-dom';
import { ContentLayout } from './ContentLayout';
export const PortalHeaderLayout = ({ header = true, sider = true, withoutSiderAndHeaderRouter = [], withoutHeaderRouter = [], withoutSiderRouter = [], canChangeCompany = false, headerTabs = [], hasBase = false, children, ...rest }) => {
    const location = useLocation();
    if (withoutSiderAndHeaderRouter?.includes(location.pathname)) {
        return _jsx(ContentLayout, {});
    }
    if (header && !sider) {
        return (_jsx(HeaderLayout, { canChangeCompany: canChangeCompany, headerTabs: headerTabs, hasBase: hasBase }));
    }
    if (sider && !header) {
        return _jsx(SiderLayout, {});
    }
    return (_jsx(BasicLayout, { canChangeCompany: canChangeCompany, headerTabs: headerTabs, ...rest }));
};
